import Vue from 'vue'
import BzbsCustom from '@/core/Custom/service/BzbsCustom.js'
export default {
  getTermVersion() {
    const url = '/nestle/pdpaconsent/terms/' + Vue.bzbsConfig.client_id + '/version.json'
    return new Promise((resolve, reject) => {
      BzbsCustom.apiGetCustom(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPrivacyVersion() {
    const url = '/nestle/pdpaconsent/privacy/version.json'
    return new Promise((resolve, reject) => {
      BzbsCustom.apiGetCustom(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}